<template>
  <div>
    <MainNoticeDialog
      :is-show="isMainNoticeDialogOpen"
      @close="isMainNoticeDialogOpen = false"
      @show="isMainNoticeDialogOpen = true"
      v-show="isMainNoticeDialogOpen"
    />
    <div class="dashboard h-full not-full">
      <Profile />
      <Loan :status="status" :getStatusInProgress="getStatusInProgress" />
      <Delivery />
      <Banner />
    </div>
  </div>
</template>

<script>
import MainNoticeDialog from '@/components/modal/MainNoticeDialog'
import Profile from './components/profile/Profile'
import Loan from './components/loan/Loan'
import Banner from './components/banner/Banner'
import Delivery from './components/delivery/Delivery'

import UserService from '@/service/user/UserService'
import StatusService from '@/service/status/StatusService'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    MainNoticeDialog,
    Profile,
    Loan,
    Banner,
    Delivery,
  },
  data() {
    return {
      isMainNoticeDialogOpen: false
    }
  },
  computed: {
    ...mapState('status', {
      status: 'status'
    }),
    ...mapGetters('status', {
      getStatusInProgress: 'getStatusInProgress'
    }),
  },
  async created() {
    if (!this.status.code) {
      await StatusService.syncStatus()
    }
    await UserService.isKycVerified()
  },
  methods: {
  }
}
</script>
